<div class="growl-container">
    <p-growl [value]="notifications" [life]="life" (onClose)="onClose($event)" (onClick)="onNotificationClicked($event)"
        [ngClass]="{'web-notifications' : notifications.length && notifications[notifications.length - 1].notify }"
        [baseZIndex]="99999">
    </p-growl>
</div>